import { useProfileStore } from '@/store/useProfileStore.ts';
import Discovery from '@/components/Discovery/Discovery.tsx';
import Guard from '@/components/Guard/Guard.tsx';

const Search = () => {
  const { aboutMe, remainingAmount } = useProfileStore();

  return (
    <Guard component="search">
      <Discovery aboutMe={aboutMe} remainingAmount={remainingAmount} />
    </Guard>
  );
};

export default Search;
